import { RecentlyViewedPatient } from '../../../types/patients'

export interface RecentlyViewedState {
	list: Array<RecentlyViewedPatient>
}

export enum RECENTLY_VIEWED_ACTION_TYPES {
	SET_VIEWED = 'RECENTLY_VIEWED_SET_VIEWED',
}

export interface SetViewedPatientAction {
	type: RECENTLY_VIEWED_ACTION_TYPES.SET_VIEWED
	payload: RecentlyViewedPatient
}

export type RecentlyViewedAction = SetViewedPatientAction
